module.exports = __webpack_public_path__ + "static/22-6a09ff4a12e002f675fdf40a05f06211.jpg";